import { render, staticRenderFns } from "./DisclaimerConfirm.vue?vue&type=template&id=16499c12&scoped=true"
import script from "./DisclaimerConfirm.vue?vue&type=script&lang=js"
export * from "./DisclaimerConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16499c12",
  null
  
)

export default component.exports